export const MessageEmpty = {
    messageForCustomer : "メッセージがありません",
    messageForClient : "プロへメッセージを送ってみましょう",
};



// WEBPACK FOOTER //
// ./src/config/view_const/message.ts